export const CodeStore = {
  activityList: undefined,
  taskList: undefined,
  expenselist: undefined
};
export default class CodeService {
  constructor(leanLawApi, http, leanLawAuth, alerts) {
    this.leanLawApi = leanLawApi;
    this.http = http;
    this.leanLawAuth = leanLawAuth;
    this.alerts = alerts;
  }
  async activityCodes() {
    if (CodeStore.activityList) {
      return Promise.resolve(CodeStore.activityList);
    }
    this.domain = `${this.leanLawAuth.domain}/v1`;
    const path = `${this.domain}/codes/activity`;
    try {
      const {
        data
      } = await this.http.get(path);
      const activityList = data.map(code => ({
        id: code.id,
        value: code.id,
        label: `${code.id} ${code.label}`,
        listLabel: `${code.id} ${code.label}`,
        disabled: code.isDisabled
      }));
      CodeStore.activityList = activityList;
      return activityList;
    } catch (err) {
      this.alerts.error(err);
    }
  }
  async taskCodes() {
    if (CodeStore.taskList) {
      return Promise.resolve(CodeStore.taskList);
    }
    this.domain = `${this.leanLawAuth.domain}/v1`;
    const path = `${this.domain}/codes/task`;
    try {
      const {
        data
      } = await this.http.get(path);
      const taskList = data.map(code => ({
        id: code.id,
        value: code.id,
        label: `${code.id} ${code.label}`,
        listLabel: `${code.id} ${code.label}`,
        disabled: code.isDisabled
      }));
      CodeStore.taskList = taskList;
      return taskList;
    } catch (err) {
      this.alerts.error(err);
    }
  }
  async expenseCodes() {
    if (CodeStore.expenselist) {
      return Promise.resolve(CodeStore.expenselist);
    }
    this.domain = `${this.leanLawAuth.domain}/v1`;
    const path = `${this.domain}/codes/expense`;
    try {
      const {
        data
      } = await this.http.get(path);
      const expenselist = data.map(code => ({
        id: code.id,
        value: code.id,
        label: `${code.id} ${code.label}`,
        listLabel: `${code.id} ${code.label}`,
        disabled: code.isDisabled
      }));
      CodeStore.expenselist = expenselist;
      return expenselist;
    } catch (err) {
      this.alerts.error(err);
    }
  }
}